export default "/images/vendor/flag-icons/flags/1x1/md.svg?01ec3194a89e6a0c56765a04410c2461";